import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Footer from '../components/footer'
import Header from '../components/header'
import './index.css'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { property: 'description', content: 'Conoce a través de varios especiales, todo sobre la Liga de Campeones. Una serie de artículos sobre el torneo más importante del fútbol de Europa como es la Uefa Champions League.' },
        { property: 'keywords', content: 'liga de campeones, UCL, champions league, champions, futbol, futbol de europa, especiales champions, especiales liga campeones, futbol europeo' },
        { property: 'og:title', content: 'Liga de Campeones: Todo sobre el torneo más importante del futbol de Europa.' },
        { property: 'og:description', content: 'Conoce a través de varios especiales, todo sobre la Liga de Campeones. Una serie de artículos sobre el torneo más importante del fútbol de Europa como es la Uefa Champions League.' },
        { property: 'og:image', content: 'https://cdn3.uvnimg.com/94/e6/c897105f45e6b625e571d9e2bf4e/promo-image-uefa.jpg' },
        { property: 'og:url', content: `https://www.univision.com${process.env.PREFIX_PATH}` },
        { property: 'twitter:title', content: 'Liga de Campeones: Todo sobre el torneo más importante del futbol de Europa.' },
        { property: 'twitter:description', content: 'Conoce a través de varios especiales, todo sobre la Liga de Campeones. Una serie de artículos sobre el torneo más importante del fútbol de Europa como es la Uefa Champions League.' },
        { property: 'twitter:image', content: 'https://cdn3.uvnimg.com/94/e6/c897105f45e6b625e571d9e2bf4e/promo-image-uefa.jpg' },
        { property: 'twitter:card', content: 'summary_large_image' },
        
      ]}
    />
    <Header Pages={data.allSitePage.edges}/>
    <div
      style={{
        
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    allSitePage{
      edges {
        node {
          id
          path
          context 
          {
            slug
            node{
              title
              label
              description
              publishDate
              type
              index
              author_name
              author_image
            }
          }
        }
      }
    }
  }`


// WEBPACK FOOTER //
// ./src/layouts/index.js